import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { coupleService } from "@/services/api";
import { useAuth } from "@/hooks/useAuth";

export const DEFAULT_LABELS = {
  agora: "Agora", dinheiro: "Dinheiro", planos: "Planos", vida: "Vida",
  agora_title: "o presente, do jeito que ele é.", dinheiro_eyebrow: "nosso dinheiro", dinheiro_title: "A espinha, não a personalidade.",
  planos_eyebrow: "nossos planos", planos_title: "Álbum do que vem.", vida_eyebrow: "nossa vida", vida_title: "O que a gente construiu.",
};

export function useCouple() {
  const qc = useQueryClient();
  const { user } = useAuth();
  const q = useQuery({ queryKey: ["couple"], queryFn: coupleService.get, enabled: !!user });
  const couple = q.data?.couple;
  const profiles = q.data?.profiles || [];
  const me = profiles.find((p) => p.id === user?.id) || user;
  const partner = profiles.find((p) => p.id !== user?.id);

  const updateCouple = useMutation({
    mutationFn: coupleService.update,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["couple"] }),
  });
  const updateProfile = useMutation({
    mutationFn: coupleService.updateProfile,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["couple"] }),
  });

  const discreet = !!couple?.discreet_mode;
  const toggleDiscreet = () => updateCouple.mutate({ discreet_mode: !discreet });
  const nameOf = (id) => profiles.find((p) => p.id === id)?.name || "—";
  const labels = { ...DEFAULT_LABELS, ...Object.fromEntries(Object.entries(couple?.menu_labels || {}).filter(([, v]) => v)) };

  return { ...q, couple, profiles, me, partner, discreet, toggleDiscreet, updateCouple, updateProfile, nameOf, labels };
}
